import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = [{
    label: 'INICIO',
    href: '#inicio'
  }, {
    label: 'ACERCA',
    href: '#acerca'
  }, {
    label: 'SERVICIOS',
    href: '#servicios'
  }, {
    label: '¿POR QUÉ ARRENDAR?',
    href: '#porque'
  }, {
    label: 'CONTACTO',
    href: '#contacto'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-transparent'}`} data-id="element-187">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188">
        <div className="flex items-center justify-between h-20" data-id="element-189">
          {/* Logo */}
          <div className="flex items-center" data-id="element-190">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tPwrCXF6FTrYeWwGEzRyLi/logo-header.png" alt="ArrendaLogic" className="h-12 w-auto" data-id="element-191" />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-192">
            {navItems.map(item => <a key={item.label} href={item.href} className={`text-sm font-medium transition-colors relative group ${isScrolled ? 'text-gray-700 hover:text-[#1da4dd]' : 'text-white hover:text-[#1da4dd]'}`} data-id="element-193">
                {item.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#1da4dd] transition-all group-hover:w-full" data-id="element-194"></span>
              </a>)}
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2" data-id="element-195">
            {isMobileMenuOpen ? <XIcon className={isScrolled ? 'text-gray-700' : 'text-white'} size={24} data-id="element-196" /> : <MenuIcon className={isScrolled ? 'text-gray-700' : 'text-white'} size={24} data-id="element-197" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-t" data-id="element-198">
          <div className="px-4 py-4 space-y-3" data-id="element-199">
            {navItems.map(item => <a key={item.label} href={item.href} onClick={() => setIsMobileMenuOpen(false)} className="block text-gray-700 hover:text-[#1da4dd] font-medium" data-id="element-200">
                {item.label}
              </a>)}
          </div>
        </div>}
    </nav>;
}